var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.window.hide_header
    ? _c("div", { staticClass: "container-xl" }, [
        _c("div", { staticClass: "header bg-solid position-relative" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [_c("itinerary-adv-form", { attrs: { forceAdvView: true } })],
              1
            ),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }